// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__FSyTG"};